module.exports = __webpack_public_path__ + "img/errorimage.1.4fc55f23.png";